module.exports = __webpack_public_path__ + "img/g_mro_2.231170fc.png";